/** Evidence profile (row detail tab and summary graphs). true in test; false in production until launch. */
export const isEvidenceProfileEnabled = process.env.REACT_APP_SHOW_EVIDENCE_PROFILE === 'true';
